import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import {
  FaHome,
  FaUsers,
  FaCog,
  FaChevronDown,
  FaChevronUp,
  FaProductHunt,
  FaAsterisk,
  FaBuffer,
  FaFileInvoice,
  FaStore,
} from "react-icons/fa";
import "./SidebarMenu.css";
import { useNavigate } from "react-router-dom";
import {
  setAddonsModal,
  setFabricModal,
  setSizeModal,
  setSublimationSizeModal,
} from "../../API/Reducer/fabricReducer";
import { useDispatch } from "react-redux";
import { setProductCatgModal } from "../../API/Reducer/productCategoryReducer";

const SidebarMenu = ({ closeModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (key) => {
    setOpenMenu(openMenu === key ? null : key);
  };

  return (
    <>
      <div className="sidebar-wrapper">
        <div className="menu-section">
          <div
            className="menu-item"
            onClick={() => {
              navigate("/admin/product");
              closeModal();
            }}
          >
            <FaProductHunt className="menu-icon" />
            <span>Product</span>
          </div>

          <div className="menu-item" onClick={() => toggleMenu("master")}>
            <FaBuffer className="menu-icon" />
            <div className="menu-label-wrapper">
              <span>Master</span>
              <span className="chevron">
                {openMenu === "users" ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <Collapse in={openMenu === "master"}>
            <div className="submenu">
              <div
                className="submenu-item"
                onClick={() => {
                  dispatch(setProductCatgModal());
                  closeModal();
                }}
              >
                Category
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  dispatch(setFabricModal());
                  closeModal();
                }}
              >
                Fabric
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  dispatch(setSizeModal());
                  closeModal();
                }}
              >
                Size
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/banner");
                  closeModal();
                }}
              >
                Banner
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  dispatch(setSublimationSizeModal());
                  closeModal();
                }}
              >
                Sublimation Size
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sublimation-cloth");
                  closeModal();
                }}
              >
                Sublimation Cloth
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sublimation-print-type");
                  closeModal();
                }}
              >
                Sublimation Print Type
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sublimation-print-addon");
                  closeModal();
                }}
              >
                Sublimation Print Addon
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  dispatch(setAddonsModal());
                  closeModal();
                }}
              >
                Addons
              </div>
            </div>
          </Collapse>

          <div className="menu-item" onClick={() => toggleMenu("bills")}>
            <FaFileInvoice className="menu-icon" />
            <div className="menu-label-wrapper">
              <span>Billing</span>
              <span className="chevron">
                {openMenu === "bills" ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <Collapse in={openMenu === "bills"}>
            <div className="submenu">
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/quotation-list");
                  closeModal();
                }}
              >
                Quotation
              </div>
            </div>
          </Collapse>

          <div className="menu-item" onClick={() => toggleMenu("users")}>
            <FaUsers className="menu-icon" />
            <div className="menu-label-wrapper">
              <span>Users</span>
              <span className="chevron">
                {openMenu === "users" ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <Collapse in={openMenu === "users"}>
            <div className="submenu">
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/users");
                  closeModal();
                }}
              >
                All Users
              </div>
            </div>
          </Collapse>

          <div className="menu-item" onClick={() => toggleMenu("ecom")}>
            <FaStore className="menu-icon" />
            <div className="menu-label-wrapper">
              <span>Ecommerce</span>
              <span className="chevron">
                {openMenu === "ecom" ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </div>
          </div>
          <Collapse in={openMenu === "ecom"}>
            <div className="submenu">
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/catg-sub-list");
                  closeModal();
                }}
              >
                Category
              </div>   
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sup-list");
                  closeModal();
                }}
              >
                Supplier
              </div> 
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/product-list");
                  closeModal();
                }}
              >
                Product
              </div>           
            </div>
          </Collapse>

          <div className="menu-item" onClick={() => toggleMenu("settings")}>
            <FaAsterisk className="menu-icon" />
            <span>Feature</span>
            <span className="chevron">
              {openMenu === "settings" ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <Collapse in={openMenu === "settings"}>
            <div className="submenu">
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/main-sequence");
                  closeModal();
                }}
              >
                Category Reorder
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/main-product-sequence");
                  closeModal();
                }}
              >
                Main Product Reorder
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sub-product-sequence");
                  closeModal();
                }}
              >
                Sub Product Reorder
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/bulk-price");
                  closeModal();
                }}
              >
                Bulk Price
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/sublimation-price");
                  closeModal();
                }}
              >
                Sublimation Price
              </div>
              <div
                className="submenu-item"
                onClick={() => {
                  navigate("/admin/partners-logo");
                  closeModal();
                }}
              >
                Trusted Partners
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default SidebarMenu;
